/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Papa from 'papaparse';

export interface ParsedLastValueCsvRow {
    timestamp: string;
    unit: string;
    urn: string;
    value: string;
}

export interface ParsedLastValueCsv {
    columns: string[];
    rows: ParsedLastValueCsvRow[];
}

export function parseLastValueCsv(csv: string): ParsedLastValueCsv {
    const parseResult = Papa.parse<ParsedLastValueCsvRow>(csv, {
        delimiter: ';',
        header: true,
        skipEmptyLines: true,
    });

    return {
        columns: parseResult.meta.fields ?? ['timestamp', 'urn', 'value', 'unit'],
        rows: parseResult.data.map((row) => ({
            timestamp: row.timestamp?.trim() ?? '',
            unit: row.unit?.trim() ?? '',
            urn: row.urn?.trim() ?? '',
            value: row.value?.trim() ?? '',
        })),
    };
}
